// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-transmit-double"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M1 20H12V10H6V4H1V20Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12 20H23V10H17V4H12V20Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 20V9L7 4H1V20H12ZM12 20H23V9L18 4H12V20ZM17 4V10H23M6 4V10H12","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.79 16.29L16.4972 15.0001L17.79 13.71M6.20996 16.29L7.50282 15.0001L6.20997 13.71","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileTransmitDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-transmit-double',
    ref,
    icon: element,
  },
));

FileTransmitDoubleIcon.displayName = 'FileTransmitDoubleIcon';

export default FileTransmitDoubleIcon;
